module.exports = __webpack_public_path__ + "img/2016-4.b377b8ce.jpg";